import { useEffect } from "react";
import { useMutation } from "@tanstack/react-query";
import { useSearchParams } from "react-router-dom";

import useYardActionEvents, {
    CustomerData,
} from "@hsl/core/hooks/useYardAnalyticsEvents";
import useFCSubscriptionStore from "@hsl/fc-subscription/store";

import { Translate } from "../../../../../hooks/useTranslation";
import { UserDetailsService } from "../../../../../openapi";
import EnvelopeCheckIcon from "../../../../icons/EnvelopeCheck";
import Spinner from "../../../../Spinner";
import { Card } from "../../Card";

export const VerifyEmail = () => {
    const pageName = "Verify email";
    const { clickLinkEvent, pageLoadEvent } = useYardActionEvents();
    const [, setSearchParams] = useSearchParams();
    const getStepData = useFCSubscriptionStore(
        (state) => state.getFlowStepData,
    );
    const email = getStepData("add-details")?.data?.data?.email;

    const resend = useMutation({
        mutationFn: async () => {
            await UserDetailsService.resendUserEmail({ email });
        },
        onError: (error) => {
            console.error(error);
            alert("Could not resend email");
        },
    });
    useEffect(() => {
        const data = getStepData("add-details")?.data;
        if (data) {
            const customer: CustomerData = data.data;
            setTimeout(() => {
                pageLoadEvent({ pageName, customer });
            }, 50);
        }
    }, []);
    return (
        <Card className="flex flex-col items-center gap-4 pt-12">
            <EnvelopeCheckIcon className="w-24 shrink-0" />
            <h1 className="text-base max-sm:text-center sm:text-xl">
                <Translate>
                    Please go to your inbox to verify your email
                </Translate>
            </h1>
            <p className="max-sm:text-center">
                <Translate>Email address</Translate>:{" "}
                <span className="pii font-medium">{email}</span>
            </p>
            <div className="mt-4 flex flex-wrap items-center gap-4 max-sm:flex-col max-sm:pb-8 sm:gap-12">
                <button
                    type="button"
                    className="text-core-blue underline"
                    onClick={() => {
                        resend.mutate();
                        clickLinkEvent({ name: "Resend email" });
                    }}
                >
                    {resend.isLoading ? (
                        <Spinner />
                    ) : resend.isSuccess ? (
                        <>
                            <Translate>Sent</Translate>!
                        </>
                    ) : (
                        <Translate>Re-send email</Translate>
                    )}
                </button>
                <button
                    type="button"
                    className="text-core-blue underline"
                    onClick={() => {
                        setSearchParams((params) => {
                            params.set("step", "add-details");
                            return params;
                        });
                        clickLinkEvent({
                            name: "Change email address",
                        });
                    }}
                >
                    <Translate>Change email address</Translate>
                </button>
            </div>
        </Card>
    );
};
